// extracted by css-extract-rspack-plugin
export default {"root":"fp9rin","header":"pE3Duu","subheader":"OwHAWm"};